import { DATA_REGION_KEY } from '../lib/session-state';

/**
 * DataResidency — where this account's (or this person's) data lives, stated in jurisdiction
 * terms (ADR-124 D4/I6; ADR-122 Part B).
 *
 * ⭐ THE LABEL IS THE SERVER'S. `/portal/me` answers with `zoneLabel`, resolved server-side from
 * the zone that answered (which IS the home zone — the browser resolved it before calling), and
 * `useAuth` mirrors it into sessionStorage — the same value the COG's "Data region" row shows.
 * Nothing here maps a code to a name, so a new zone never renders a stale or guessed label.
 *
 * ⛔ NO LABEL, NO LINE. Omitted rather than defaulted — a residency statement is never printed
 * from a guess (region-routing.ts's own rule).
 */
export function readDataRegion(): string | null {
  try {
    return sessionStorage.getItem(DATA_REGION_KEY);
  } catch {
    return null;
  }
}

/** Beside a snippet (install page, activation modal): ADR-124 I6's sentence, verbatim. */
export function DataStoredIn({ className = 'data-stored-in' }: { className?: string }) {
  const label = readDataRegion();
  if (!label) return null;
  return (
    <p className={className} data-testid="data-stored-in">
      Your data is stored in {label}
    </p>
  );
}

/**
 * A dashboard's home zone (Consultant, Partner — ADR-124 D4: it bounds who they can serve). Same
 * words as the COG's "Data region" row; small and read-only.
 */
export function DataRegionLine({ className = 'data-region-line' }: { className?: string }) {
  const label = readDataRegion();
  if (!label) return null;
  return (
    <div className={className} data-testid="dashboard-data-region">
      Data region: {label}
    </div>
  );
}
